import { h, Component } from "preact";
import { css } from "emotion";

import InputWrapper from "./InputWraper";

const teaxAreaStyle = css({
  appearance: "none",
  width: "100%",
  maxWidth: "100%",
  borderRadius: 4,
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: "#8D949E",
  backgroundColor: "#f9f9fa",
  fontSize: 16,
  padding: 12,
  "@media(max-width: 600px)": {
    width: "100%",
    height: 100,
    fontSize: 14
  }
});

const TextAreaField = ({
  name,
  type,
  placeholder,
  label,
  input,
  meta: { touched, error }
}) => {
  return (
    <InputWrapper touched={touched} error={error} label={label}>
      <textarea
        name={input.name}
        {...input}
        type={type}
        placeholder={placeholder}
        type={type}
        data-cy={`${input.name} input`}
        aria-label={`${input.name} input`}
        rows="4"
        className={teaxAreaStyle}
      />
    </InputWrapper>
  );
};

export default TextAreaField;
